<div
  class="component-container text-cool-grey h-[100%] flex flex-col justify-center items-center space-y-[2.4rem]">
  <div
    class="questions-form-container md:w-[80%] w-full flex flex-col justify-center items-center">
    <div
      class="heading font-poppins font-bold mb-[2.4rem] flex justify-center ">
      Your Details
    </div>
    <div
      *ngIf="obQuestionLoader; else displayAdultForm"
      class="loader w-full flex justify-center items-center"
    >
      <mat-spinner
        [diameter]="100"
        mode="indeterminate"
        strokeWidth="5"
      />
    </div>
    <ng-template
      #displayAdultForm
    >
      <div
        *ngFor="let question of questionList,let i = index"
        [ngSwitch]="question.dataType"
        class="w-full"
      >
        <ng-container
          *ngSwitchCase="1"
        >
          <app-dropdown
            (checkForErrors)="checkForErrors($event)"
            [controlName]="''+question.key"
            [error]="errorMessages[''+question.key]"
            [label]="question.question"
            [options]="question.options"
            [parentFormGroup]="form"
            [tooltipText]="question.tooltipText"
            class="input"
            placeholder="Select one"
            type="small"
          />
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="pronounOthersSelected && question.key=== 'whatDoYouLikeToBeCalled'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.otherPronoun.length.max"
            [minLength]="validation.onboarding.otherPronoun.length.min"
            [parentFormGroup]="form"
            label="Other"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-input>
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="preferredLanguageOthersSelected && question.key=== 'preferredLaguage'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.otherLang.length.max"
            [minLength]="validation.onboarding.otherLang.length.min"
            [parentFormGroup]="form"
            label="Other preferred language"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-input>
        </ng-container>
        <ng-container
          *ngSwitchCase="2"
        >
          <app-dropdown
            (checkForErrors)="checkForErrors($event)"
            [controlName]="''+question.key"
            [enableMultiple]="true"
            [error]="errorMessages[''+question.key]"
            [label]="question.question"
            [options]="question.options"
            [parentFormGroup]="form"
            [tooltipText]="question.tooltipText"
            class="input"
            placeholder="Select all that apply"
            type="small"
          />
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="selfDescriptionOthersSelected && question.key=== 'selfDescribe'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.other.length.max"
            [parentFormGroup]="form"
            label="Other race"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-input>
        </ng-container>

      </div>
    </ng-template>
    <div class="action-section w-full">
      <app-primary-button
        (handleClick)="continue()"
        [isLoading]="saveAnswersLoading"
        type="small"
      >
        CONTINUE
      </app-primary-button>
    </div>
    <span
      class="note font-work-sans font-light flex justify-center text-center">
      Required fields are marked with an asterisk (*)
    </span>
  </div>
</div>
